var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetaViradoParaBaixo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24118 1.04051C7.24118 0.593138 6.8813 0.230469 6.43736 0.230469C5.99343 0.230469 5.63355 0.593138 5.63355 1.04051V10.4261L2.18275 6.94853C1.86884 6.63219 1.35989 6.63219 1.04598 6.94853C0.732069 7.26488 0.732069 7.77777 1.04598 8.09411L5.11108 12.1907C5.84354 12.9288 7.03109 12.9288 7.76354 12.1907L11.8266 8.09622C12.1405 7.77988 12.1405 7.26699 11.8266 6.95064C11.5126 6.6343 11.0037 6.6343 10.6898 6.95064L7.24118 10.426V1.04051Z",
    fill: "#E4003A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaViradoParaBaixo);
export default __webpack_public_path__ + "static/media/setaViradoParaBaixo.205ba5983e2c17197aacf94b18b56ac0.svg";
export { ForwardRef as ReactComponent };